// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImgS6 from '../img/Figure_S6.png';

function Gaap09(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title">Genome annotation</h2>
            <h2 className="content_title2">Structural annotation</h2>
            <h2 className="contnet_description">(5) Post-processing to add UTR annotation</h2>
            <div className="content_text">
                GAAP uses PASA to update the EVM consensus gene 
                predictions, adding UTRs and modeling alternatively spliced isoforms.
            </div>
            <div className="content_command_title">PASA</div><br/>
            <div className="content_text">
                The Program to Assemble Spliced Alignments (PASA) 
                can update any gene structure annotations by correcting 
                exon boundaries, and adding UTRs and alternatively spliced 
                models based on assembled transcriptomic data.
            </div>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="http://pasapipeline.github.io" /><br/>
                </div>
            </div><br/>
            <li className="content_description">Database Generation Command</li>
            <div className="content_text">
                First, before running PASA, the gff3 result file, 
                obtained from EVM (evm.out.gff3), is stored within 
                a relational database (MySQL)
            </div>
            <CommandBox lines={[
                {data: `scripts/Load_Current_Gene_Annotations.dbi 
                    -c config.file -g genome.fasta -P evm.out.gff3`},
            ]}
            /><br/>
            <li className="content_description">Options for database generation</li>
            <OptionTable
                data={[
                    {   option:'-c',
                        desc:`specify the config file`},
                    {   option:'-g',
                        desc:`specify the assembled genome file`},
                    {   option:'-P',
                        desc:`specify the annotated results file(EVM results file)`},
                ]}
            /><br />
            <li className="content_description">Configuration File</li>
            <div className="content_text">
                The name of the database is set by the MYSQLDB 
                option in the configuration file.
            </div>
            <CommandBox lines={[
                {data: `# MySQL settings`},
                {data: `MYSQLDB=myPasaDB`},
            ]}
            /><br/>
            <li className="content_description">Execution Command</li>
            <CommandBox lines={[
                {data: `scripts/Launch_PASA_pipeline.pl -c config.file 
                        -A -g genome.fasta -t trinity.fasta`},
            ]}
            /><br/>
            <li className="content_description">Options for execution</li>
            <OptionTable
                data={[
                    {   option:'-c',
                        desc:`specify the config file`},
                    {   option:'-g',
                        desc:`specify the assembled genome file`},
                    {   option:'-t',
                        desc:`specify the assembled transcriptome file`},
                ]}
            /><br />

            <li className="content_description">Output of PASA</li>
            <div className="content_text">
                *.gff3: store the updated gene structures with UTR 
                information and protein sequences&nbsp;
                <ShowImg name="(Supplementary Figure S6)"
                        src= {figureImgS6}
                />.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap08"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap10"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap09;